import { queryOptions } from '@tanstack/react-query'
import { billingApi } from './api'
import { UsageEventTypeValue, UsageGroupByValue } from './models'

type UsageParams = {
  organization: string | null | undefined
  startDate?: string
  endDate?: string
  eventType?: UsageEventTypeValue
  groupBy?: UsageGroupByValue
}

export const billingQueries = {
  all: () => ['billing'],

  /** The caller's orgs with balances — for pickers that must bill a chosen org. */
  wallets: () =>
    queryOptions({
      queryKey: [...billingQueries.all(), 'wallets'],
      queryFn: () => billingApi.csc.listWallets(),
    }),

  wallet: (organization: string | null | undefined) =>
    queryOptions({
      queryKey: [...billingQueries.all(), 'wallet', organization],
      queryFn: () => billingApi.csc.getWallet({ organization: organization! }),
      enabled: Boolean(organization),
    }),

  rates: (organization: string | null | undefined) =>
    queryOptions({
      queryKey: [...billingQueries.all(), 'rates', organization],
      queryFn: () => billingApi.csc.getRates({ organization: organization! }),
      enabled: Boolean(organization),
      // Rates change infrequently; cache aggressively to avoid refetching.
      staleTime: 1000 * 60 * 60,
    }),

  usage: ({ organization, startDate, endDate, eventType, groupBy }: UsageParams) =>
    queryOptions({
      queryKey: [
        ...billingQueries.all(),
        'usage',
        { organization, startDate, endDate, eventType, groupBy },
      ],
      queryFn: () =>
        billingApi.csc.getUsage({
          organization: organization!,
          startDate,
          endDate,
          eventType,
          groupBy,
        }),
      enabled: Boolean(organization),
    }),
}
